import { get } from 'lodash';

import { isInternalUser } from './user';

export const getPayments = state => state.payments;

// return the currency for the users payment profile
export const getCurrency = state => getPayments(state).currency;

// return if the payments have not been fetched yet, or if they are in
// progress for fetching
export const isPaymentsLoading = state => {
  const { fetched, fetching } = getPayments(state);
  return !fetched || fetching;
};

// return true if payments are connected
export const isPaymentsConnected = state =>
  get(getPayments(state), 'adyen.isConnected', false);

// return if the payments are fetched already and not loading again
export const arePaymentsLoaded = state => {
  const { fetched, fetching } = getPayments(state);
  return fetched && !fetching;
};

// return the payment method for this user based on groups and flags
export const getPaymentsMethod = state => {
  if (isInternalUser(state)) {
    return 'internal';
  }

  return 'adyen';
};

export const getPaymentsErrorMessage = state => {
  // don't update the error message if we're still loading
  if (isPaymentsLoading(state)) {
    return;
  }

  // internal users don't have payments
  if (getPaymentsMethod(state) === 'internal') {
    return;
  }

  if (getPaymentsMethod(state) === 'adyen') {
    const {
      adyen: {
        connectionError,
        formDetailsError,
        systemError,
      },
    } = getPayments(state);

    if (formDetailsError) {
      return formDetailsError;
    }

    if (connectionError) {
      return connectionError;
    }

    if (systemError) {
      return 'Contact adstudio@spotify.com if you\'re having trouble.';
    }
  }
};



// WEBPACK FOOTER //
// ./src/selectors/payments.js